import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JBInnerHtmlModule } from '@shared/jb-inner-html';
import { LinkIconModule } from '@shared/link-icon/link-icon.module';
import { UIModule } from '@shared/ui';
import {
  JbIconModule,
  JbLinkModule,
  JbRelatedContentBlockModule,
} from 'jb-component-library';

import {
  PageRelatedContentBlockContainerComponent,
  pageRelatedContentBlockContainerResolver,
} from './page-related-content-block-container.component';

const MODULES = [
  CommonModule,
  UIModule,
  JbRelatedContentBlockModule,
  JbIconModule,
  JbLinkModule,
  JBInnerHtmlModule,
  LinkIconModule,
];

const DECLARATIONS = [PageRelatedContentBlockContainerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class PageRelatedContentBlockContainerModule {
  static entry = PageRelatedContentBlockContainerComponent;
  static componentDataResolver = pageRelatedContentBlockContainerResolver;
}
